import React, { useState } from "react"

import { TextField, IconButton } from "@material-ui/core"

import {
  Delete as DeleteIcon,
  Add as AddIcon,
  Remove as RemoveIcon
} from "@material-ui/icons"

const Item = ({ info, onDelete, onQuantityUpdate, product, translation }) => {
  const [quantity, setQuantity] = useState(info.quantity)

  const decrease = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1)
      onQuantityUpdate(info.id, product.id, quantity - 1)
    }
  }

  const increase = () => {
    if (quantity <= 50) {
      setQuantity(quantity + 1)
      onQuantityUpdate(info.id, product.id, quantity + 1)
    }
  }

  const change = e => {
    let newQuantity = parseInt(e.target.value, 10)

    console.log("Change: ", e.target.value, newQuantity)

    if (isNaN(newQuantity)) {
      setQuantity(0)
    } else {
      if (newQuantity <= 0 || newQuantity > 50) {
        newQuantity = 1
      }

      setQuantity(newQuantity)
      onQuantityUpdate(info.id, product.id, newQuantity)
    }
  }

  const ua = translation.language === "ua"
  const name = translation.translateKey(product, "name")

  return (
    <li className="item">
      <div className="item__info basket__item">
        <div className="photo__item">
          <img
            src={`${process.env.REACT_APP_API}/media/${product.picture.split(",")[0]
              }`}
            alt=""
          />
        </div>
        <span className="item__name">{name}</span>
      </div>
      <div className="price__item basket__item">
        <span className="basket__label">{ua ? "Ціна" : "Цена"}</span>
        <span>
          {product.with_action ? product.new_price.toLocaleString() : product.price.toLocaleString()} грн
        </span>
      </div>
      <div className="quantity basket__item">
        <div className="quantity__stepper">
          <IconButton
            onClick={decrease}
            className="delete__item"
            size="small"
            aria-label={ua ? `Зменшити кількість: ${name}` : `Уменьшить количество: ${name}`}
          >
            <RemoveIcon fontSize="small" />
          </IconButton>
          <TextField
            variant="outlined"
            error={!quantity}
            label={quantity ? "" : "Введіть число"}
            value={quantity ? quantity : ""}
            onChange={change}
            margin="dense"
            type="number"
            inputProps={{ "aria-label": ua ? `Кількість: ${name}` : `Количество: ${name}` }}
          />
          <IconButton
            onClick={increase}
            className="add__item"
            size="small"
            aria-label={ua ? `Збільшити кількість: ${name}` : `Увеличить количество: ${name}`}
          >
            <AddIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      <div className="total__item basket__item">
        <span className="basket__label">{ua ? "Разом" : "Сумма"}</span>
        <span>
          {(quantity * (product.with_action ? product.new_price : product.price)).toLocaleString()} грн
        </span>
      </div>
      <div className="delete basket__item">
        <IconButton onClick={onDelete} aria-label={ua ? `Видалити: ${name}` : `Удалить: ${name}`}>
          <DeleteIcon className="remove__item" />
        </IconButton>
      </div>
    </li>
  )
}

export default Item
